import { fetcher } from "@weezevent/weezjs-core";

export const updateAttendeesAccessRights = ({ organizationId, payload }) => {
	const endpoint = `/organizations/${organizationId}/attendees/actions`;

	const options = {
		data: payload,
		endpoint: window.weezConfig.api.apiUrl,
		cache: false
	};

	return fetcher.post(endpoint, options);
};

export const getAttendeesActionTaskStatus = ({ organizationId, taskId }) => {
	const endpoint = `/organizations/${organizationId}/async-tasks/actions/${taskId}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		cache: false
	};

	return fetcher.get(endpoint, options);
};
